import { render, staticRenderFns } from "./MonthsEstablishmentSettingAdd.vue?vue&type=template&id=6213c9cb&scoped=true&"
import script from "./MonthsEstablishmentSettingAdd.vue?vue&type=script&lang=js&"
export * from "./MonthsEstablishmentSettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213c9cb",
  null
  
)

export default component.exports